export class Proveedor {
    idProveedor = 0;
    nombre = '';
    contacto = '';
    email = '';
    telefono = '';
    activo = true;
    clabe = '';
    noCuenta = '';
    sucursal = '';
    banco = '';
    beneficiario = '';
    razonSocial = '';
    rfc = '';
    diasCredito = 0;
    selected = false;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/proveedor.ts